import * as Yup from "yup";

export const ChequeContractStep3FormValidation = Yup.object({
  first_party_id: Yup.number().required("طرف اول را وارد نمایید"),
  second_party_id: Yup.number().required("طرف دوم را وارد نمایید"),
});
